import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook to check for authentication tokens in URL hash and redirect as needed
 */
export function useAuthRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check for hash parameters
    if (window.location.hash) {
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const accessToken = hashParams.get('access_token');
      const type = hashParams.get('type');

      // If we have an access token and it's a recovery (password reset)
      if (accessToken && type === 'recovery') {
        console.log('Recovery token detected in URL, redirecting to reset password page');
        // Pass the entire hash to keep all auth params
        navigate(`/reset-password${window.location.hash}`);
        return;
      }

      // If we have an access token and it's signup or invite
      if (accessToken && (type === 'signup' || type === 'invite')) {
        console.log('Signup/invite token detected in URL, redirecting to set password page');
        navigate(`/set-password${window.location.hash}`);
        return;
      }
    }
  }, [navigate]);

  return null;
} 